<template>
  <div class="print-box tem p-1">
    <table class="prtable prtable-center prtable-bordered">
      <tr>
        <td>Tên hàng</td>
        <td colspan="4" style="font-size: 13px;">
          <b v-if="manufacture.product">{{ manufacture.product.name }} </b>
          <!-- <span v-if="manufacture.productCustom != ''"><br>{{ manufacture.productCustom }}</span> -->
          <b v-if="manufacture.reason"><br />{{ manufacture.reason.name }}</b>
        </td>
      </tr>
      <tr>
        <td>Mã SP</td>
        <td colspan="4" style="font-size: 15px;">
          <b v-if="manufacture.product">{{ manufacture.product.code }}</b>
        </td>
      </tr>
      <tr>
        <td>Quy cách</td>
        <td colspan="2" style="font-size: 15px;">
          <b v-if="manufacture.productSpecify">{{ manufacture.productSpecify.name }}</b>
        </td>
        <td colspan="2" style="font-size: 15px;">mm</td>
        <!-- <td>{{ manufacture.length }} cm</td> -->
      </tr>
      <tr>
        <td>Chiều dài</td>
        <td colspan="2" style="font-size: 15px;">
          {{ manufacture.length }}
        </td>
        <td colspan="2" style="font-size: 15px;">cm</td>
      </tr>
      <tr>
        <td>Màu sắc</td>
        <td colspan="2" style="font-size: 15px;">
          <b>{{ manufacture.colorText }}</b>
        </td>
        <td colspan="2" style="font-size: 15px;">{{ manufacture.colorCode1 }}</td>
      </tr>
      <tr>
        <td>Số lượng</td>
        <td style="font-size: 15px;">
          <b>{{ Tem.slbich }}</b>
        </td>
        <td style="font-size: 15px;">{{ manufacture.unit }}</td>
        <td colspan="2" style="font-size: 15px;">
          <span style="display: flex;align-items:center">
            <span style="width:100%" title="Số cuộn hoặc số bịch">{{ Tem.slcbich }}</span>
            <div style="width:100%">
              <span style="display:block; border-bottom:1px solid #000">C</span>
              <span>B</span>
            </div>
          </span>
        </td>
      </tr>
      <tr>
        <td>Số Lot</td>
        <td colspan="2" style="font-size: 15px;">
          <b>{{ manufacture.code }}</b>
        </td>

        <td colspan="2" style="font-size: 15px;">
          <span title="Trọng lượng gộp của 1 tem">
            {{ $formatNumberFixed(Number(this.Tem.hesobich) * Number(this.Tem.slcbich) + Number(this.Tem.tlbich)) }}
          </span>
        </td>
      </tr>
      <tr>
        <td>QC</td>
        <td colspan="2" style="width:100px; font-size: 15px;">
          <base-input
            title="Trọng lượng ống lõi hoặc trọng lượng bịt"
            v-model="Tem.hesobich"
            placeholder="Hệ số"
            :mask="'number'"
          ></base-input>
        </td>
        <td colspan="2" style="font-size: 15px;">
          <span title="trong lượng tịnh của 1 tem"> {{ $formatNumberFixed(Tem.tlbich) }}</span>
        </td>
      </tr>
      <tr>
        <td>Note</td>
        <td colspan="4" style="width:100px; font-size: 15px;">
          <textarea v-model="Tem.note" class="form-control"></textarea>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: 'tem-bich',
  props: {
    manufacture: {},
    code: {},
    Tem: {},
    quantityOdd: {}
  }
};
</script>
